import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

// start Vuex
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    member_id: false
  },
  mutations: {
    increment (state) {
      state.count++
    }
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  }
})

// start MaterialKit
import MaterialKit from "./plugins/material-kit";
Vue.use(MaterialKit);
const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

// start loading overlay
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

// start lodash
import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// start config setup
import { CONFIG as SiteConfig } from './config';
Object.defineProperty(Vue.prototype, '$conf', { value: SiteConfig });

// start axios
import axios from 'axios';
// axios.defaults.withCredentials=true;
Vue.prototype.$http = axios;

// start numeral
import numeral from 'numeral';
Object.defineProperty(Vue.prototype, '$numeral', { value: numeral });

window.eventHub = new Vue();

// session token
router.beforeEach(async (to, from, next) => {
  // get a token if not available
  
  if(!localStorage.getItem('member_id')){
    let response = await axios({
      method: "POST",
      baseURL: `${SiteConfig.API_HOST}`,
      url: "token_get.php",
      data: {
        
      }
    });

    localStorage.setItem('member_id', response.data.member_id);
    localStorage.setItem('member_token', response.data.member_token);

    store.state.member_id = response.data.member_id;

    next();
  }else{
    store.state.member_id = localStorage.getItem('member_id');
    next();
  }

  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ['/login'];
  // const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem('user');

  // if (authRequired && !loggedIn) {
  //   return next('/login');
  // }
})

// wx.config({
//   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//   appId: 'wx5d1a77c08bb4134a', // 必填，公众号的唯一标识
//   timestamp: 1567496347, // 必填，生成签名的时间戳
//   nonceStr: 'h2QHj0192jJiMNxnwI5523KLJkkU', // 必填，生成签名的随机串
//   signature: '1b3002a90a62ac191691aa6f23673470a4e40439',// 必填，签名
//   jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
// });

// wx.ready(function(){
//   // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
//   console.log("WX is Ready NOW!");
// });

// wx.error(function(res){
//   console.log("WX got an ERROR");
//   console.log(res);
//   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
// });

// i18n
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
import i18n_en from "./i18n/en.json";
import i18n_cn from "./i18n/cn.json";
import i18n_zh from "./i18n/zh.json";

// Ready translated locale messages
const messages = {
  en: i18n_en,
  cn: i18n_cn,
  zh: i18n_zh,
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'cn', // set locale
  messages, // set locale messages
});

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
